import styled from 'styled-components';

export const BadgeContainer = styled.div<{ color: string }>`
  display: flex;
  width: 14px;
  height: 14px;
  padding: 2px 4px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  position: absolute;
  right: -2.5px;
  color: #edeff5;
  top: -2.5px;
  border-radius: 8px;
  background: ${({ color }) => color};
  box-shadow: 0px 1px 1px 0px rgba(239, 241, 243, 0.2) inset;
  z-index: 100;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%; /* 14px */
`;

export const IconContainer = styled.span`
  /* margin-right: 0.5em; */
`;
